import React, { useRef, useState } from 'react'
import SbEditable from 'storyblok-react'
import FluidImage from 'src/utils/FluidImage'
import PlayButton from 'src/images/play_button.svg'
import ConnectCharacter from 'src/images/connect_character.svg'
import Wave from 'src/utils/Wave'
import Heading from 'src/components/Heading'
import Button from 'src/components/Button'
import RichText from 'src/utils/RichText'

const Video = ({ blok }) => {
  const vidRef = useRef(false)
  const [hide, setHide] = useState(false)
  const handlePlayVideo = () => {
    vidRef.current.play()
    setHide(true)
  }

  const _onReady = event => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo()
  }

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div>
        <div
          className={`relative bg-brightgreen ${
            !blok.isContent && 'bg-white py-12 px-6'
          }`}
          style={{ backgroundColor: blok.backgroundColor || '' }}
        >
          {blok.title_above_video && (
            <Heading
              size="h2"
              className="text-darkblue brightgreenBold text-center max-w-3xl mx-auto mb-6"
            >
              <RichText>{blok.title_above_video}</RichText>
            </Heading>
          )}
          {blok.title && (
            <Heading
              size="h2"
              className="text-darkblue brightgreenBold text-center max-w-3xl mx-auto mb-6"
            >
              <RichText>{blok.title}</RichText>
            </Heading>
          )}

          {blok.Youtube_video ? (
            <div className="relative sm:max-w-4xl max-w-lg mx-auto">
              <div className="relative z-10 rounded-xl shadow-2xl">
                {/* Youtube Embed Video */}
                <iframe
                  width="1157"
                  height="651"
                  src={`https://www.youtube.com/embed/${
                    blok.Youtube_video?.match(/[?&]v=([^&]+)/)?.[1]
                  }`}
                  title="Cloud Gateway: Securely Connecting Anything to Everything"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  className="rounded-xl z-10 block w-full md:h-[500px] sm:h-[50vh] h-[29vh] object-cover not-prose border-8 border-emerald-400"
                ></iframe>
              </div>
            </div>
          ) : (
            <div className="relative max-w-7xl mx-auto">
              <div className="relative z-10 rounded-xl shadow-2xl border-8 border-emerald-400">
                <video
                  src={blok.cdn_video ? blok.cdn_video : blok.video?.filename}
                  type="video/mp4"
                  preload="auto"
                  controls
                  width="1920"
                  height="1080"
                  muted
                  controlsList="nodownload"
                  ref={vidRef}
                  className="rounded-xl z-10 block w-full h-full object-cover not-prose"
                >
                  Sorry, your browser doesn't support embedded videos.
                </video>
              </div>
              <div
                onClick={handlePlayVideo}
                onKeyDown={handlePlayVideo}
                role="button"
                tabIndex="0"
                className={`rounded-xl absolute block z-10 top-0 left-0 w-full h-full object-cover cursor-pointer transition-all duration-500 ease-in-out focus:outline-none outline-none ${
                  hide ? 'opacity-0 invisible' : 'opacity-100 visible'
                }`}
              >
                <FluidImage
                  className="rounded-xl z-10 block w-full h-full object-cover not-prose"
                  image={blok.thumbnail}
                />
                <div className="absolute z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 sm:h-20 h-12 sm:w-20 w-12 rounded-full text-white">
                  <PlayButton className="w-full h-full" />
                </div>
              </div>
            </div>
          )}
          <div className="max-w-7xl mx-auto mt-3 text-center space-y-6">
            <div className="md:max-w-[70%] mx-auto">
              {/* <Heading size="h5" className="text-darkblue font-semibold !mb-1">
                {blok.title}
              </Heading> */}
              <p className="md:text-base text-sm tracking-[-0.03em] mt-8 text-darkblue">
                {blok.description}
              </p>
            </div>
            <Button
              to={blok.button_target?.cached_url}
              className="bg-darkblue hover:bg-darkbluehover before:content-[attr(before)]"
              before={blok.button_text}
            >
              {blok.button_text}
            </Button>
          </div>
        </div>
      </div>
    </SbEditable>
  )
}

export default Video
